// this file is for global actions, which affect the app as a whole
import {createAction} from '@reduxjs/toolkit';

export const initApp = createAction('app/init');

export type GlobalActions = ReturnType<typeof initApp>;
